import logo from "../../oversight-core/assets/images/logo_bw.svg";

const Logo = () => {
  return <img src={logo} alt="oversight_logo" />;
};

export default Logo;
